const LANGUAGE_INDEX = 1;
const COUNTRY_INDEX = 2;
const LOCALE_SEGMENT_REGEX = /\/([a-z]{2})-([a-z]{2}|eu|global)\//;
export const getLocaleFromURL = (url: string) => {
    const match = LOCALE_SEGMENT_REGEX.exec(url.toLowerCase());
    return match
        ? { language: match[LANGUAGE_INDEX], country: match[COUNTRY_INDEX] }
        : {};
};
